export default "__VITE_ASSET__69e5eaff__"